import { useEffect, useState } from "react";
import "./landingNavbar.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";


// context
import { AppContext } from "../../../contexts/appCotext";

// ui-component
import LogoContainer from "../../UI/LogoContainer/LogoContainer";

// icon
import { hamburgerMenuIcon } from "../../../constants/icons";

const LandingNavbar = () => {
  const {toggleNavDrawer} = useContext(AppContext)
  const navigate = useNavigate();
  const location = useLocation()
  const [showAuthBtns, setShowAuthBtns] = useState<boolean>(true);

  useEffect(()=>{
    const pathname = location.pathname.split('/')[1];
    if(pathname === "invite"){
      setShowAuthBtns(false);
    }
    // eslint-disble-next-line
  },[location])

  return (
    <div className="landingNavbar">
      <div className="container">
        <LogoContainer/>
        {
          showAuthBtns &&

          <div className="actionButtonHolder">
          <button className="signin"
            onClick={() =>{
              navigate('/auth/signin')
            }}
          >
              Sign-in
          </button>
          <button className="signup"
          onClick={() =>{
            navigate('/auth/signup')
          }}
          >
              Sign-up
          </button>
      </div>
        }
       
        <div className="hamburgerMenu" onClick={toggleNavDrawer}>
            {hamburgerMenuIcon}
        </div>
      </div>
    </div>
  );
};

export default LandingNavbar;
